import { z } from 'zod'

// the three instrument types the picker can browse (bond/etf/share)
export const INSTRUMENT_TYPES = ['share', 'etf', 'bond'] as const
export type InstrumentType = (typeof INSTRUMENT_TYPES)[number]

export const instrumentUniverseQuerySchema = z.object({
  type: z.enum(INSTRUMENT_TYPES),
})
export type InstrumentUniverseQueryDto = z.infer<typeof instrumentUniverseQuerySchema>

export const universeInstrumentSchema = z.object({
  uid: z.string(),
  figi: z.string(),
  ticker: z.string(),
  name: z.string(),
  instrumentType: z.enum(INSTRUMENT_TYPES),
  classCode: z.string(),
  isin: z.string(),
  currency: z.string(),
  lot: z.number(),
  exchange: z.string(),
  sector: z.string().nullable(),
  countryOfRisk: z.string(),
  apiTradeAvailableFlag: z.boolean(),
  buyAvailableFlag: z.boolean(),
  sellAvailableFlag: z.boolean(),
  // bond-only; null for shares/etfs
  maturityDate: z.string().nullable(),
  nominal: z.number().nullable(),
  couponsPerYear: z.number().nullable(),
})
export type UniverseInstrumentDto = z.infer<typeof universeInstrumentSchema>

export const instrumentUniverseResponseSchema = z.object({
  instruments: z.array(universeInstrumentSchema),
  cachedAt: z.string(), // ISO timestamp of when the universe was fetched
})
export type InstrumentUniverseResponseDto = z.infer<typeof instrumentUniverseResponseSchema>
